module.exports = __webpack_public_path__ + "assets/images/pages/unleash/ball-4.png?046a8a27";